import { useState } from "react";
import { Button, Card, CardTitle, Input } from "@electro-planner/ui";
import { authClient } from "../lib/auth.ts";

export function OrganizationsRoute() {
  const list = authClient.useListOrganizations();
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleCreate(e: React.FormEvent) {
    e.preventDefault();
    setPending(true);
    setError(null);
    try {
      const res = await authClient.organization.create({ name, slug });
      if (res.error) {
        setError(res.error.message ?? "Kunde inte skapa organisation.");
      } else {
        setName("");
        setSlug("");
      }
    } finally {
      setPending(false);
    }
  }

  async function handleSetActive(organizationId: string) {
    await authClient.organization.setActive({ organizationId });
  }

  return (
    <div className="mx-auto max-w-3xl space-y-6 p-6">
      <Card>
        <CardTitle>Skapa organisation</CardTitle>
        <form className="flex flex-col gap-3" onSubmit={handleCreate}>
          <Input
            placeholder="Namn (t.ex. Björn El AB)"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Input
            placeholder="slug (bjorn-el)"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
          />
          <Button type="submit" disabled={pending || !name || !slug}>
            Skapa
          </Button>
          {error && <p className="text-sm text-[var(--color-danger)]">{error}</p>}
        </form>
      </Card>

      <Card>
        <CardTitle>Dina organisationer</CardTitle>
        {list.isPending ? (
          <p className="text-sm text-[var(--color-muted)]">Laddar…</p>
        ) : list.data && list.data.length > 0 ? (
          <ul className="divide-y divide-[var(--color-border)]">
            {list.data.map((o) => (
              <li key={o.id} className="flex items-center justify-between py-2">
                <div>
                  <div className="font-medium">{o.name}</div>
                  <div className="text-xs text-[var(--color-muted)]">{o.slug}</div>
                </div>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => handleSetActive(o.id)}
                >
                  Sätt aktiv
                </Button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-[var(--color-muted)]">
            Du är inte medlem i någon organisation än. Skapa en ovan.
          </p>
        )}
      </Card>
    </div>
  );
}
